module.exports = __webpack_public_path__ + "static/booking-car-new-2-7c153102d1e6c2e0d00c3cdc01afbe73.png";